import { create } from 'zustand';

import { AvailableTimeSlot, Location } from '@src/lib/__generated/vetspire/sdk';
import { persistWithExpiry } from '@src/store/middleware/persist-with-expiry';
import { mountDevTools } from '@src/store/utils/mount-dev-tools';

export type TimeSlotState = {
	timeSlot: AvailableTimeSlot | null;
	timeSlotFacility: Location | null;
	timeSlotTaken: boolean;
	timeStamp: string | null;
};

export type TimeSlotActions = {
	setTimeSlot: (timeSlot: AvailableTimeSlot | null) => void;
	setTimeSlotFacility: (timeSlotFacility: Location | null) => void;
	setTimeSlotTaken: (timeSlotTaken: boolean) => void;
	reset: () => void;
};

const INITIAL_STATE: TimeSlotState = {
	timeSlot: null,
	timeSlotFacility: null,
	timeSlotTaken: false,
	timeStamp: null,
	// timestamp is used to track the last time the time slot was set
};

const useTimeSlotStore = create<TimeSlotState & TimeSlotActions>()(
	persistWithExpiry(
		(set) => ({
			...INITIAL_STATE,
			setTimeSlot: (timeSlot) =>
				set({
					timeSlot,
					timeStamp: timeSlot ? Date.now() : null,
				}),
			setTimeSlotFacility: (timeSlotFacility) => set({ timeSlotFacility }),
			setTimeSlotTaken: (timeSlotTaken) => set({ timeSlotTaken }),
			reset: () => set(INITIAL_STATE),
		}),
		{
			name: 'book-an-appointment-time-slot',
		}
	)
);

mountDevTools('useTimeSlotStore', useTimeSlotStore);

export default useTimeSlotStore;
